    <div id="tabPort" fxLayout="column" fxLayoutAlign="center" class="pt-16">
      <form name="formSearch" [formGroup]="formSearch" (ngSubmit)="onSearchSubmit(formSearch)">
        <div class="courses" fxLayout="row wrap" fxLayoutAlign="center">
          <mat-form-field appearance="outline" floatLabel="always" 
            class="pr-8" fxFlex="100" fxFlex.gt-xs="50"
            fxFlex.gt-md="25">
            <mat-label>Country of Loading</mat-label>
            <input type="text" aria-label="Country of Loading" matInput formControlName="country_of_loading" [matAutocomplete]="autoCOL" required>
            <mat-autocomplete #autoCOL="matAutocomplete">
              <mat-option *ngFor="let item of filteredCountry1" [value]="item.name">
                {{item.name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="formSearch.get('country_of_loading').hasError('required')">
              Field is required
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" 
            class="pr-8" fxFlex="100" fxFlex.gt-xs="50"
            fxFlex.gt-md="25">
            <mat-label>Port of Loading</mat-label>
            <input type="text" aria-label="Port of Loading" matInput formControlName="pol" [matAutocomplete]="autoPOL" [readonly]="formSearch.get('country_of_loading').hasError('required')" required>
            <mat-autocomplete #autoPOL="matAutocomplete">
              <mat-option *ngFor="let item of filteredPort1" [value]="item.name">
                {{item.name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="formSearch.get('pol').hasError('required')">
              Field is required
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" 
            class="pr-8" fxFlex="100" fxFlex.gt-xs="50"
            fxFlex.gt-md="25">
            <mat-label>Country of Discharge</mat-label>
            <input type="text" aria-label="Country of Discharge" matInput formControlName="country_of_discharge" [matAutocomplete]="autoCOD" required>
            <mat-autocomplete #autoCOD="matAutocomplete">
              <mat-option *ngFor="let item of filteredCountry2" [value]="item.name">
                {{item.name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="formSearch.get('country_of_discharge').hasError('required')">
              Field is required
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" 
            class="pr-8" fxFlex="100" fxFlex.gt-xs="50"
            fxFlex.gt-md="25">
            <mat-label>Port of Discharge</mat-label>
            <input type="text" aria-label="Port of Discharge" matInput formControlName="pod" [matAutocomplete]="autoPOD" [readonly]="formSearch.get('country_of_discharge').hasError('required')" required>
            <mat-autocomplete #autoPOD="matAutocomplete">
              <mat-option *ngFor="let item of filteredPort2" [value]="item.name">
                {{item.name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="formSearch.get('pod').hasError('required')">
              Field is required
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" 
            class="pr-8" fxFlex="100" fxFlex.gt-xs="50"
            fxFlex.gt-md="33">
            <mat-label>Depart time</mat-label>
            <input matInput [matDatepicker]="pickerEtd" formControlName="etd" required>
            <mat-datepicker-toggle matSuffix [for]="pickerEtd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEtd></mat-datepicker>
            <mat-error *ngIf="formSearch.get('pod').hasError('required')">
              Field is required
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always" 
            class="pr-8" fxFlex="100" fxFlex.gt-xs="50"
            fxFlex.gt-md="33">
            <mat-label>Container type</mat-label>
            <input matInput placeholder="Enter a type"
            formControlName="type" readonly (click)="openContainerModal()" required>
            <mat-error *ngIf="formSearch.get('type').hasError('required')">
              Field is required
            </mat-error>
          </mat-form-field>
          <div style="display: none">
              <input formControlName="volume">
          </div>
          <div class="pt-4 pb-24 pr-8" fxFlex="100" fxFlex.gt-xs="50"
              fxFlex.gt-md="34">
            <button style="width: 100%; height: 100%" color="accent" mat-raised-button type="submit" [disabled]="!formSearch.valid">
              Search
            </button>
          </div>
        </div>
      </form>
    </div>